import React, { useEffect, useState } from 'react';
import { Form, DatePicker, Button, Row, Col, message, Select, Typography } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import moment from 'moment';
import usePermissions from '../../hooks/usePermissions';

const FLOrdersSummary = ({ handleClose }) => {
    const [loading, setLoading] = useState({
        formSubmission: false
    });
    const [form] = Form.useForm();
    const { hasPermission } = usePermissions();

    const hasP1 = hasPermission("can_download_daily_fl_order_sheet_start_date_wise");
    const hasP2 = hasPermission("can_download_daily_fl_order_sheet_deadline_wise");
    const hasP3 = hasPermission("can_download_any_fl_sheet");

    const hasBothPermissions = hasP1 && hasP2;
    const hasAllPermissions = (hasP1 || hasP2) && hasP3;

    const [queryType, setQueryType] = useState(hasBothPermissions ? null : hasP1 ? "start_date" : "deadline");
    const [dropdownList, setDropdownList] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [p3Type, setP3Type] = useState(null);

    console.log("p3Type", p3Type)

    const fetchDropdownList = async () => {
        setLoading(prev => ({ ...prev, getDropdown: true }));
        try {
            const res = await axiosInstance.get("/task/v2/freelancer-dropdown/");
            if (res.status === 200) {
                setDropdownList(res.data.data || []);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(prev => ({ ...prev, getDropdown: false }));
        }
    };

    useEffect(() => {
        if (hasP3) {
            fetchDropdownList();
        }
    }, []);

    const handleFinish = async (values) => {
        setLoading(prev => ({ ...prev, formSubmission: true }));
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');

            let finalQueryType = queryType;
            if (hasBothPermissions) {
                finalQueryType = values.query_type;
            }
            if (hasP3) {
                finalQueryType = p3Type === "all" ? (hasBothPermissions ? values.query_type : queryType) : "any";
            }

            const params = {
                from_date,
                to_date,
                query_type: finalQueryType,
                email: hasP3 && (p3Type === "specific" ||
                    (p3Type === null)
                ) ? selectedEmail : undefined,
            };

            const response = await axiosInstance.get('/task/v2/freelancer-sheet/', {
                params,
                responseType: 'blob'
            });

            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success("Sheet Download Successfully");
                handleClose();
            } else {
                message.error("Something went wrong");
            }
        } catch (err) {
            if (err?.response?.data instanceof Blob && err?.response?.headers['content-type']?.includes('application/json')) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg = errorJson?.message || errorJson?.detail || 'Error downloading sheet';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error("Unknown error");
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(prev => ({ ...prev, formSubmission: false }));
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleFinish}>
            {hasAllPermissions && (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Choose Type"
                            name="p3Type"
                            rules={[{ required: true, message: 'Please select query type' }]}
                        >
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select Query Type"
                                onChange={(value) => setP3Type(value)}
                            >
                                <Select.Option value="all">All</Select.Option>
                                <Select.Option value="specific">Specific</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            )}

            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>

            {hasBothPermissions && (!hasP3) && (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Select Type"
                            name="query_type"
                            rules={[{ required: true, message: 'Please select query type' }]}
                        >
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select Query Type"
                                onChange={(value) => setQueryType(value)}
                            >
                                <Select.Option value="start_date">Start Date</Select.Option>
                                <Select.Option value="deadline">Deadline</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            )}

            {hasP3 && (p3Type === "all") && (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Select Type"
                            name="query_type"
                            rules={[{ required: true, message: 'Please select query type' }]}
                        >
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select Query Type"
                                onChange={(value) => setQueryType(value)}
                            >
                                {hasP1 && <Select.Option value="start_date">Start Date</Select.Option>}
                                {hasP2 && <Select.Option value="deadline">Deadline</Select.Option>}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            )}


            {(hasP3 && p3Type === "specific") ? (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Select From List"
                            name="email"
                            rules={[{ required: true, message: 'Please select an option from the list' }]}
                        >
                            <Select
                                placeholder="Select an option"
                                onChange={(value) => setSelectedEmail(value)}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                                optionFilterProp="children"
                                allowClear
                            >
                                {dropdownList.map(item => (
                                    <Select.Option key={item.email} value={item.email}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            ) : (hasP3 && (p3Type == null) && p3Type !== "all") ? (<Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select From List"
                        name="email"
                        rules={[{ required: true, message: 'Please select an option from the list' }]}
                    >
                        <Select
                            placeholder="Select an option"
                            onChange={(value) => setSelectedEmail(value)}
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            optionFilterProp="children"
                            allowClear
                        >
                            {dropdownList.map(item => (
                                <Select.Option key={item.email} value={item.email}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>) : null}

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={loading.formSubmission}>
                    Submit
                </Button>
            </div>

            <Typography.Text type="secondary" style={{ fontSize: "12px", marginTop: "8px", display: "block" }}>
                {hasP3
                    ? ""
                    : hasP1 && !hasP2
                        ? "Note: Data will be shown based on order start date."
                        : hasP2 && !hasP1
                            ? "Note: Data will be shown fl assigned deadline."
                            : ""}
            </Typography.Text>
        </Form>
    );
};

export default FLOrdersSummary;
